import { jsx as _jsx } from "react/jsx-runtime";
import { memo, useMemo } from "react";
import { Provider } from "react-redux";
import { makeStore } from "~/store";
import { setCentralizedPublicBoardAction } from "~/store/centralizedBoard/actions";
import { setSavedConfigurableViewsAction } from "~/store/configViews/actions";
export const PublicBoardReduxProvider = /*#__PURE__*/ memo((param)=>{
    let { children, initialBoard } = param;
    const { store } = useMemo(()=>{
        const { store } = makeStore({
            centralizedBoard: initialBoard
        });
        store.dispatch(setCentralizedPublicBoardAction({
            board: initialBoard
        }));
        store.dispatch(setSavedConfigurableViewsAction({
            savedConfigurableViews: initialBoard.views
        }));
        return {
            store
        };
    }, [
        initialBoard
    ]);
    return /*#__PURE__*/ _jsx(Provider, {
        store: store,
        children: children
    });
});
PublicBoardReduxProvider.displayName = "PublicBoardReduxProvider";
